class objectsUtil {
    plain(o) {
        if (o !== undefined) {
            return JSON.parse(JSON.stringify(o));
        }
        return o;
    }
}

export default new objectsUtil();
